import { departureDateStore } from '@/infrastructure/departure-date/store'
import { currencyResolver } from '@/intl/currencyResolver'
import { roomsParticipantsDistributionStore } from '@/scopes/common/components/Filters/ParticipantsLegacy/store'
import { availabilityApiClient } from '@/scopes/prices/infrastructure/availability'
import { bookingDraftApiClient } from '@/scopes/prices/infrastructure/booking-draft'
import { filtersAPIClient } from '@/scopes/prices/infrastructure/filters'
import { pricesAPIClient } from '@/scopes/prices/infrastructure/pricesByDuration'
import { promotedPriceAPIClient } from '@/scopes/prices/infrastructure/promoted-price'
import { roomSelectorApiClient } from '@/scopes/prices/infrastructure/rooms'
import { flightSelectorApiClient, selfDriveSelectorApiClient } from '@/scopes/prices/infrastructure/transport'
import { paginationResolver } from '@/scopes/search/search/domain/paginationResolver'
import { searchAPIClient } from '@/scopes/search/search/infrastructure/api'
import { searchPageQueryBuilder } from '@/scopes/search/search/infrastructure/browser/searchPageQueryBuilder'
import { searchStore } from '@/scopes/search/search/infrastructure/store/store'
/**
 * @deprecated This file is deprecated and will be removed in the future.
 * Use specific page dependency context or common dependencies from `common.ts`.
 */
export const defaultDependencies = {
  currencyResolver,
  // TODO: Move dependencies below to their own domain
  searchAPIClient,
  searchStore,
  searchPageQueryBuilder,
  departureDateStore,
  paginationResolver,
  filtersAPIClient,
  pricesAPIClient,
  roomsParticipantsDistributionStore,
  roomSelectorApiClient,
  flightSelectorApiClient,
  selfDriveSelectorApiClient,
  bookingDraftApiClient,
  promotedPriceAPIClient,
  availabilityApiClient,
}

export type AppDependencies = typeof defaultDependencies
